import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesEquipe {
  ler: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC necessário para o módulo
 * Equipe: a lista de membros vem de `GET /auth/usuarios` (recurso `auth`,
 * `apps/api/src/modules/auth/auth.routes.ts`) — só `admin` (curinga `*`)
 * tem `ler`, nenhum outro papel foi seedado (mesmo grant de
 * `permissoesUsuarios`). As regras de comissão (`comissoes_regras`,
 * migration `024`) e categorias (`categorias_servico`, migration `026`)
 * também incluem `financeiro`, mas sem a lista de usuários a tela não
 * tem o que mostrar — por isso o gate é o mais restritivo dos três
 * (`auth:ler`), nunca inventado.
 */
export function permissoesEquipe(papel: PapelUsuario): PermissoesEquipe {
  if (papel === 'admin') return { ler: true };
  return { ler: false };
}
